import react, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  agentHeader,
  maliciousDetectionsHeader,
  threatHunterSingleAgentAnalysisHeader,
} from "../../../../utils/constants/tableHeaders";
import CloseIcon from "../../../Icon-SVG/CloseIcon";
import LineAltIcon from "../../../Icon-SVG/LineAltIcon";
import CustomTable from "../../../common/Table/CustomTable";
import TabButton from "../../../common/TabButton/TabButton";
import { getStoredPageSize } from "../../../common/PageSizeSelect/PageSizeSelect";
import ReactTableWrapper from "../../../common/ReactTableWrapper/ReactTableWrapper";
import {
  RequestSingleAgentDataThunter,
  RequestSingleAgentIocResults,
} from "../../../../store/actions/integrationsActions";
import { RequestSubmissionsList } from "../../../../store/actions/dashboardActions";
import {
  filterByDistinctGroupID,
  isCompressedItself,
  isNotRelatedToCompressed,
} from "../../../../utils/function";

import "./styles.scss";

const formPluralWording = (word, amount) => {
  if (amount === 0 || amount === 1) return word;
  else return `${word}s`;
};

const Modal = ({ selectedAgent }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [runningCounter, setRunningCounter] = useState(0);
  const [activeTab, setActiveTab] = useState("Threat Hunter");

  const selectedAgentTHunterScanResults = useSelector(
    (state) => state.integrations.threatHunterList,
  );
  const selectedAgentTHunterScanResultsLoading = useSelector((state) => state.integrations.loading);
  const selectedAgentIocResults = useSelector((state) => state.integrations.agentIocResults);
  const selectedAgentIocResultsLoading = useSelector(
    (state) => state.integrations.agentIocResultsLoading,
  );
  const fileAnalysisList = useSelector((state) => state.dashboard.list);
  const fileAnalysisRowCount =
    fileAnalysisList?.filter(
      (filterData, i, arr) =>
        filterByDistinctGroupID(filterData, i, arr) &&
        (isCompressedItself(
          filterData.compressedID,
          filterData.compressedIDfull,
          filterData.fileIDfull,
        ) ||
          isNotRelatedToCompressed(filterData.compressedID)),
    )?.length || 0;

  const threatHunterListRowOnClick = (row) => {
    const id = row?.original?.id;

    history.push(`/analysis-reports?data=${id}&type=threat-hunter`);
  };

  useEffect(() => {
    dispatch(
      RequestSingleAgentDataThunter({
        clientID: selectedAgent.clientID,
        cpuID: selectedAgent.cpuID,
        hostname: selectedAgent.hostname,
        macAddress: selectedAgent.macAddress,
      }),
    );

    dispatch(
      RequestSingleAgentIocResults({
        clientID: selectedAgent.clientID,
        cpuID: selectedAgent.cpuID,
        hostname: selectedAgent.hostname,
        macAddress: selectedAgent.macAddress,
      }),
    );

    dispatch(
      RequestSubmissionsList({
        selectedTimeFilter: null,
        // Same size the table below starts with
        customPageSize: getStoredPageSize("agent", 10),
        pageNumber: 1,
        tableName: "agent",
        agentHostname: selectedAgent.hostname,
      }),
    );

    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [dispatch, selectedAgent]);

  const closePopupHandler = () => {
    history.goBack();
  };

  return ReactDOM.createPortal(
    <div className="agent__backdrop" onClick={closePopupHandler}>
      <div className="agent__modal" onClick={(e) => e.stopPropagation()}>
        <div className="agent__content">
          <div className={`agent-reports-popup`}>
            <div className="agent-reports-popup__close" onClick={closePopupHandler}>
              <CloseIcon width="18" height="18" />
            </div>
            <div className="agent-reports-popup__files">
              <LineAltIcon />
              <p>
                {selectedAgent.clientID || "Manual Install"} - Threat hunting{" "}
                {selectedAgentTHunterScanResults?.length}{" "}
                {formPluralWording("time", selectedAgentTHunterScanResults?.length)},{" "}
                {fileAnalysisRowCount} {formPluralWording("submission", fileAnalysisRowCount)},{" "}
                {selectedAgentIocResults.length}{" "}
                {formPluralWording("malicious detection", selectedAgentIocResults.length)}
              </p>
            </div>
          </div>
          <div className="agent__modal__table-wrapper">
            <div className="button-block">
              <TabButton title="Threat Hunter" onClick={setActiveTab} active={activeTab} />
              <TabButton title="File Analysis" onClick={setActiveTab} active={activeTab} />
              <TabButton title="Malicious Detections" onClick={setActiveTab} active={activeTab} />
            </div>
            <div className="agent__modal__table border">
              {activeTab === "File Analysis" ? (
                <CustomTable
                  exportFile={true}
                  column={agentHeader}
                  setRunningCounter={setRunningCounter}
                  agentHostname={selectedAgent.hostname}
                  tableName={"agent"}
                  leftAction={false}
                  tableFolder={"dashboard"}
                  isSetUrl
                  paginationButtons={true}
                  className=""
                  minBottom="5px"
                  customPageSize={10}
                  minHeightRow="72px"
                  minHeight="585px"
                  manualPagination={true}
                />
              ) : activeTab === "Threat Hunter" ? (
                <ReactTableWrapper
                  data={selectedAgentTHunterScanResults}
                  tableName={"agentStatusThreatHunter"}
                  columns={threatHunterSingleAgentAnalysisHeader}
                  // exportFile={!report}
                  paginationClassName="threat-hunter-table-pagination"
                  paginationButtons={true}
                  customPageSize={10}
                  isDataLoading={selectedAgentTHunterScanResultsLoading}
                  refreshConfig={{
                    show: true,
                    onClickHandler: () =>
                      dispatch(
                        RequestSingleAgentDataThunter({
                          clientID: selectedAgent.clientID,
                          cpuID: selectedAgent.cpuID,
                          hostname: selectedAgent.hostname,
                          macAddress: selectedAgent.macAddress,
                        }),
                      ),
                  }}
                  rowOnClickHandler={threatHunterListRowOnClick}
                  // styles={{ table: { minHeight: "585px" } }}
                />
              ) : activeTab === "Malicious Detections" ? (
                <ReactTableWrapper
                  data={selectedAgentIocResults}
                  tableName={"agentStatusIocResults"}
                  columns={maliciousDetectionsHeader}
                  paginationClassName="threat-hunter-table-pagination"
                  paginationButtons={true}
                  customPageSize={10}
                  isDataLoading={selectedAgentIocResultsLoading}
                  refreshConfig={{
                    show: true,
                    onClickHandler: () =>
                      dispatch(
                        RequestSingleAgentIocResults({
                          clientID: selectedAgent.clientID,
                          cpuID: selectedAgent.cpuID,
                          hostname: selectedAgent.hostname,
                          macAddress: selectedAgent.macAddress,
                        }),
                      ),
                  }}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.getElementById("portal"),
  );
};

export default Modal;
